import React, { Component } from "react";
import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import Responsive from "react-responsive";
import AppHeader from "../AppHeader/AppHeader";
import AppTheme from "../AppTheme";
import Checkbox from "@material-ui/core/Checkbox";

import FormControl from "@material-ui/core/FormControl";

import TextField from "@material-ui/core/TextField";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import logoImage from "../assets/logo-white.png";

import Grid from "@material-ui/core/Grid";

import Button from "@material-ui/core/Button";

import Container from "@material-ui/core/Container";

import {
  getPatientsAdmin,
  addPatient,
  deletePatient,
  getVolunteers,
  addVolunteer,
  deleteVolunteer,
  getRequests,
  archiveRequest,
  sendMessage
} from "../services/volunteer";

import styles from "./VolunteerManageStyles";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

import IconButton from "@material-ui/core/IconButton";

import SwipeableViews from "react-swipeable-views";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class VolunteerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirmDeletePatient: false,
      openConfirmDeleteRequest: false,
      openConfirmDeleteVolunteer: false,
      checked: [],
      tabValue: 0,
      patients: null,
      volunteers: null,
      requests: null,
      currentPatientId: null,
      currentRequestId: null,
      currentVolunteerId: null,
      patientName: "",
      volunteerName: "",
      volunteerPhoneNumber: "",
      messageText:"<p> ... completati aici mesajul pe care doriti sa-l trimiteti ... </p>"
    };
  }

  async componentWillMount() {
    document.title = "Program Voluntariat - Setari Voluntari";
    const patients = await getPatientsAdmin();
    const volunteers = await getVolunteers();
    const requests = await getRequests();
    this.setState({
      patients,
      volunteers,
      requests
    });
  }

  handleDeletePatient = async () => {
    await deletePatient(this.state.currentPatientId);
    const patients = await getPatientsAdmin();
    this.setState({
      currentPatientId: null,
      openConfirmDeletePatient: false,
      patients: patients
    });
  };
  handleCloseDeletePatient = () => {
    this.setState({ currentPatientId: null, openConfirmDeletePatient: false });
  };

  handleDeleteRequest = async () => {
    await archiveRequest(this.state.currentRequestId);
    const requests = await getRequests();
    this.setState({
      currentRequestId: null,
      openConfirmDeleteRequest: false,
      requests: requests
    });
  };
  handleCloseDeleteRequest = () => {
    this.setState({ currentRequestId: null, openConfirmDeleteRequest: false });
  };

  handleDeleteVolunteer = async () => {
    await deleteVolunteer(this.state.currentVolunteerId);
    const volunteers = await getVolunteers();
    this.setState({
      currentVolunteerId: null,
      openConfirmDeleteVolunteer: false,
      volunteers: volunteers
    });
  };
  handleCloseDeleteVolunteer = () => {
    this.setState({
      currentVolunteerId: null,
      openConfirmDeleteVolunteer: false
    });
  };

  AddVolunteer = async () => {
    if (!this.state.volunteerName || this.state.volunteerName === "") return;
    if (
      !this.state.volunteerPhoneNumber ||
      this.state.volunteerPhoneNumber === ""
    )
      return;
    var volunteer = {
      name: this.state.volunteerName,
      phoneNumber: this.state.volunteerPhoneNumber,
      active: true
    };
    const add = await addVolunteer(volunteer);
    const volunteers = await getVolunteers();
    this.setState({
      volunteerName: "",
      volunteerPhoneNumber: "",
      volunteers: volunteers
    });
  };
  AddPatient = async () => {
    if (!this.state.patientName || this.state.patientName === "") return;

    var patient = {
      name: this.state.patientName,
      active: true
    };
    const add = await addPatient(patient);
    const patients = await getPatientsAdmin();
    this.setState({
      patientName: "",
      patients: patients
    });
  };

  handleChangePatientName = event => {
    this.setState({ patientName: event.target.value });
  };

  handleChangeVolunteerName = event => {
    this.setState({ volunteerName: event.target.value });
  };
  handleChangeVolunteerPhoneNumber = event => {
    this.setState({ volunteerPhoneNumber: event.target.value });
  };

  handleToggleRequest = value => () => {
    const currentIndex = this.state.checked.indexOf(value);
    const newChecked = [...this.state.checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({ checked: newChecked });
    //console.log(newChecked);
  };

  sendMessage = async () => {
    var data = {
      messageText: this.state.messageText,
      recipients: []
    };
    var rec = [];
    for (var i=0; i< this.state.checked.length; i++){
      rec.push(this.state.checked[i].emailAddress)
    }
    data.recipients = rec;
    
    await sendMessage(data);
    alert("MESAJUL A FOST TRIMIS!");

    this.setState({checked:[], messageText:"<p> ... completati aici mesajul pe care doriti sa-l trimiteti ... </p>"})
  }

  render() {
    const { classes } = this.props;
    const { viewModel } = this.state;
    return (
      <MuiThemeProvider theme={AppTheme}>
        <div className={classes.volunteerForm}>
          <AppBar>
            <Toolbar>
              <i className="material-icons appToolbar-menu">menu</i>
              <img src={logoImage} style={{ height: 50 }} alt="logo" />
              <h1 className="appToolbar-title">Program Voluntariat</h1>
              <Button
                color="primary"
                variant={"contained"}
                href="/calendar"
              >
                Calendar
              </Button>
              <Button
                color="inherit"
                variant={this.state.tabValue === 1 ? "text" : "contained"}
                onClick={() => {
                  this.setState({ tabValue: 0 });
                }}
              >
                Setari Voluntari
              </Button>
              <Button
                color="inherit"
                variant={this.state.tabValue === 0 ? "text" : "contained"}
                onClick={() => {
                  this.setState({ tabValue: 1 });
                }}
              >
                Cereri Voluntariat
              </Button>
            </Toolbar>
          </AppBar>
          <SwipeableViews
            axis={"x"}
            style={{ width: "100%" }}
            index={this.state.tabValue}
            animateHeight={false}
            ref={this.swipeableViewsRef}
            onChangeIndex={index => {
              this.setState({ tabValue: index });
            }}
          >
            <Grid
              container
              spacing={2}
              style={{
                flex: 1,
                flexDirection: "row",
                margin: "90px 20px",
                width: "calc(100% - 40px)"
              }}
            >
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Paper className={classes.formContainer}>
                  <h1 style={{ marginBottom: "20px" }}>Pacienti</h1>

                  <Grid
                    container
                    style={{ width: "100%", padding: "5px 20px", marginBottom:"10px" }}
                    spacing={2}
                  >
                    <Grid style={{ flex: 1 }}>
                      <FormControl
                        className={classes.formControl}
                        fullWidth={true}
                        error={false}
                      >
                        <TextField
                          label="Nume Pacient"
                          name="patientName"
                          value={this.state.patientName}
                          onChange={this.handleChangePatientName}
                        />
                      </FormControl>
                    </Grid>
                    <Grid>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        style={{ color: "#0099ab" }}
                        onClick={this.AddPatient}
                      >
                        <AddIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  {this.state.patients && (
                    <List
                      dense={false}
                      style={{
                        width: "100%",
                        marginTop:"10px",
                        position: "relative",
                        overflow: "auto"
                      }}
                    >
                      {this.state.patients.map((item, i) => {
                        return (
                          <ListItem key={i}>
                            <ListItemAvatar>
                              <p>{i + 1}</p>
                            </ListItemAvatar>
                            <ListItemText
                              classes={{ primary: classes.listItemText }}
                              primary={item.name}
                              secondary={false}
                            />
                            <ListItemSecondaryAction>
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                style={{ color: "#f00" }}
                                onClick={() => {
                                  this.setState({
                                    openConfirmDeletePatient: true,
                                    currentPatientId: item._id
                                  });
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                        );
                      })}
                    </List>
                  )}
                  <Dialog
                    open={this.state.openConfirmDeletePatient}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClosePatient}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DialogTitle id="alert-dialog-slide-title">
                      Inactivare Pacient
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-slide-description">
                        Sunteti siguri ca vreti sa inactivati pacientul?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={this.handleCloseDeletePatient}
                        color="primary"
                      >
                        Renunta
                      </Button>
                      <Button
                        onClick={this.handleDeletePatient}
                        color="default"
                        style={{ backgroundColor: "#f77" }}
                      >
                        Da
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Paper className={classes.formContainer}>
                  <h1 style={{ marginBottom: "20px" }}>Voluntari</h1>
                  <Grid
                    container
                    spacing={2}
                    style={{ width: "100%", padding: "5px 20px",marginBottom:"10px" }}
                  >
                    <Grid style={{ flex: 1 }}>
                      <FormControl
                        className={classes.formControl}
                        fullWidth={true}
                        error={false}
                      >
                        <TextField
                          label="Nume Voluntar"
                          name="volunteerName"
                          value={this.state.volunteerName}
                          onChange={this.handleChangeVolunteerName}
                        />
                      </FormControl>
                    </Grid>
                    <Grid style={{ flex: 1 }}>
                      <FormControl
                        className={classes.formControl}
                        fullWidth={true}
                        error={false}
                      >
                        <TextField
                          label="Telefon Voluntar"
                          name="volunteerPhoneNumber"
                          value={this.state.volunteerPhoneNumber}
                          onChange={this.handleChangeVolunteerPhoneNumber}
                        />
                      </FormControl>
                    </Grid>
                    <Grid>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        style={{ color: "#0099ab" }}
                        onClick={this.AddVolunteer}
                      >
                        <AddIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  {this.state.volunteers && (
                    <List
                      dense={false}
                      style={{
                        width: "100%",
                        marginTop:"10px",
                        position: "relative",
                        overflow: "auto"
                      }}
                    >
                      {this.state.volunteers.map((item, i) => {
                        return (
                          <ListItem key={i}>
                            <ListItemAvatar>
                              <p>{i + 1}</p>
                            </ListItemAvatar>
                            <ListItemText
                              classes={{ primary: classes.listItemText }}
                              primary={item.name}
                              secondary={item.phoneNumber}
                            />
                            <ListItemSecondaryAction>
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                style={{ color: "#f00" }}
                                onClick={() => {
                                  this.setState({
                                    openConfirmDeleteVolunteer: true,
                                    currentVolunteerId: item._id
                                  });
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                        );
                      })}
                    </List>
                  )}
                  <Dialog
                    open={this.state.openConfirmDeleteVolunteer}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleCloseVolunteer}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DialogTitle id="alert-dialog-slide-title">
                      Inactivare Voluntar
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-slide-description">
                        Sunteti siguri ca vreti sa inactivati voluntarul?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={this.handleCloseDeleteVolunteer}
                        color="primary"
                      >
                        Renunta
                      </Button>
                      <Button
                        onClick={this.handleDeleteVolunteer}
                        color="default"
                        style={{ backgroundColor: "#f77" }}
                      >
                        Da
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              style={{
                flex: 1,
                flexDirection: "row",
                margin: "90px 20px",
                width: "calc(100% - 40px)"
              }}
            >
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Paper className={classes.formContainer}>
                  <h1 style={{ marginBottom: "20px" }}>
                    Cereri Voluntariat (
                    {this.state.requests ? this.state.requests.length : "0"})
                  </h1>

                  {this.state.requests && (
                    <List
                      style={{
                        width: "100%",
                        position: "relative",
                        overflow: "auto"
                      }}
                    >
                      {this.state.requests.map((item, i) => {
                        return (
                          <ListItem
                            key={i}
                            dense
                            button
                            onClick={this.handleToggleRequest(item)}
                          >
                            <ListItemIcon>
                              <Checkbox
                                edge="start"
                                checked={
                                  this.state.checked.indexOf(item) !== -1
                                }
                                tabIndex={-1}
                                disableRipple
                              />
                            </ListItemIcon>
                            <ListItemText
                              classes={{ primary: classes.listItemText }}
                              primary={item.lastName + " " + item.firstName}
                              secondary={
                                item.phoneNumber + ", " + item.emailAddress
                              }
                            />
                            <ListItemSecondaryAction>
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                style={{ color: "#f00" }}
                                onClick={() => {
                                  this.setState({
                                    openConfirmDeleteRequest: true,
                                    currentRequestId: item._id
                                  });
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                        );
                      })}
                    </List>
                  )}
                  <Dialog
                    open={this.state.openConfirmDeleteRequest}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleCloseRequest}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DialogTitle id="alert-dialog-slide-title">
                      Inactivare Cerere Voluntariat
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-slide-description">
                        Sunteti siguri ca vreti sa inactivati cererea de
                        voluntariat?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={this.handleCloseDeleteRequest}
                        color="primary"
                      >
                        Renunta
                      </Button>
                      <Button
                        onClick={this.handleDeleteRequest}
                        color="default"
                        style={{ backgroundColor: "#f77" }}
                      >
                        Da
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Paper className={classes.formContainer}>
                  <h1 style={{ marginBottom: "20px" }}>Trimite mesaj</h1>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      alignContent: "flex-start"
                    }}
                  >
                    <p style={{ textAlign: "left",flex:1,width:"100%", margin: "20px" }}>
                      
                      <b>Catre:</b>
                      {this.state.checked.map((item, i) => {
                        return <span key={i}>{item.emailAddress+ ', '}</span>;
                      })}
                    </p>
                  </div>
                  <CKEditor
                    editor={ClassicEditor}
                    style={{ minHeight: "400px",  flex: 1, margin:"40px 0" }}
                    data={this.state.messageText}
                    onInit={editor => {
                      // You can store the "editor" and use when it is needed.
                     // //console.log("Editor is ready to use!", editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                     this.setState({messageText: data});
                    }}
                  />
                  <Button
                  className={classes.sendButton}
                  variant="contained"
                  color="primary"
                  disabled={this.state.checked.length===0}
                  onClick={this.sendMessage}
                >
                  Trimite Mesaj
                </Button>
                </Paper>
              </Grid>
            </Grid>
          </SwipeableViews>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(VolunteerForm);
